export enum UserPermission {
  CREATE_PD_SESSION = 'pdCreateSession',
}
